export default "__VITE_ASSET__Bio7Fu6B__"